import * as Yup from 'yup';

import action_library_messages from 'messages/action_library_messages';

type TFunction = (key: string[] | [string, string]) => string;

const getActionTemplateValidationSchema = (t: TFunction) =>
  Yup.object().shape({
    title: Yup.string().required(t(action_library_messages.steps.validation.title_required)),
    shortDescription: Yup.string().required(t(action_library_messages.steps.validation.short_description_required)),
    criticality: Yup.string(),
    area: Yup.string().required(t(action_library_messages.steps.validation.area_required)),
    subarea: Yup.string(),
    assetTypes: Yup.array(),
    checklist: Yup.array()
      .of(
        Yup.object().shape({
          title: Yup.string().required(t(action_library_messages.steps.validation.step_title_required)),
          instruction: Yup.string().required(t(action_library_messages.steps.validation.step_instruction_required)),
          isMandatory: Yup.boolean().required(t(action_library_messages.steps.validation.mandatory_required)),
        }),
      )
      .min(1, t(action_library_messages.steps.validation.at_least_one_step_required)),
  });

export default getActionTemplateValidationSchema;
